<template>
  <div class="c-side f-Cal-Reg" :class="{'isHide': isHide, 'isBottom': isBottom}">
    <div class="c-side__wrap">
      <dl v-if="note.links">
        <!-- dt v-html="note.links.title"></dt -->
        <dd><a href="#top" @click="onAnchor">00.<br>{{note.links.top}}</a></dd>
        <dd><a href="#concept" @click="onAnchor">01.<br>{{likeNames[0]}}</a></dd>
        <dd><a href="#product-features" @click="onAnchor">02.<br>{{likeNames[1]}}</a></dd>
        <dd><a href="#lineup" @click="onAnchor">03.<br>{{likeNames[2]}}</a></dd>
      </dl>
    </div>
  </div>
</template>

<script>
  import { breakpoint } from '@/_modules/utils/variables';
  import store from '@/_modules/stores';

  export default {
    data() {
      return {
        lang: '',
        note: {},
        ispc: false,
        footerHeight: 192,
        isHide: true,
        kvHeight: 0,
        isBottom: false,
        likeNames: []
      }
    },
    store,
    created() {

    },
    mounted() {
      this.lang = this.$store.getters.getLang;
      this.note = this.$store.getters.getNote;

      if (this.lang === "zh-cmn-Hans") {
        this.likeNames[0] = '概念';
        this.likeNames[1] = '特性';
        this.likeNames[2] = '产品';
      } else if (this.lang === "zh-cmn-Hant") {
        this.likeNames[0] = '概念';
        this.likeNames[1] = '產品特色';
        this.likeNames[2] = '產品系列';
      } else if (this.lang === "es") {
        this.likeNames[0] = 'CONCEPTO';
        this.likeNames[1] = 'CARACTERÍSTICAS';
        this.likeNames[2] = 'LINE UP';
      } else {
        this.likeNames[0] = 'CONCEPT';
        this.likeNames[1] = 'FEATURES';
        this.likeNames[2] = 'LINE UP';
      }
    },
    methods: {
      start() {
        this.resize();
        window.addEventListener('resize', this.resize);
        window.addEventListener('scroll', this.scroll);
      },
      onAnchor(e) {
        this.$_onAnchor(e);
      },
      resize() {
        if (window.innerWidth > breakpoint) {
          this.ispc = true;
        } else {
          this.ispc = false;
        }

        //const rectKv = document.getElementById('c-mv').getBoundingClientRect();
        //this.kvHeight = (rectKv.height * 0.5);
        this.kvHeight = window.innerHeight * 0.6;

        this.scroll();
      },
      scroll() {
        if (this.ispc) {
          if (this.kvHeight < this.currentScrollY()) {
            this.isHide = false;
          } else {
            this.isHide = true;
          }

          //console.log(this.getScrollBottom());
          if (this.getScrollBottom() > this.footerHeight) {
            // fixed
            this.isBottom = false;
          } else {
            // absolute
            this.isBottom = true;
          }
        }
      },
      currentScrollY() {
        return window.scrollY || document.documentElement.scrollTop || document.body.scrollTop;
      },
      getScrollBottom() {
        var body = window.document.body;
        var html = window.document.documentElement;
        var scrollTop = body.scrollTop || html.scrollTop;
        return html.scrollHeight - html.clientHeight - scrollTop;
      }
    }
  }
</script>
